export default "__VITE_ASSET__Cuiy6NGj__"